module.exports = __webpack_public_path__ + "static/halodesign-07d7a4ba73cd2f825084dcf86b644de2.png";